import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
var API__UpdateSearchHistory = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var text, label_ar, label_en, searched_at, _ref$filters, filters, result_count, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          text = _ref.text, label_ar = _ref.label_ar, label_en = _ref.label_en, searched_at = _ref.searched_at, _ref$filters = _ref.filters, filters = _ref$filters === void 0 ? null : _ref$filters, result_count = _ref.result_count;
          params = {
            text: text,
            label_ar: label_ar,
            label_en: label_en,
            searched_at: searched_at,
            filters: filters,
            result_count: result_count
          };
          _context.n = 1;
          return fetcher(null, true).post("search/search-history", params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function API__UpdateSearchHistory(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default API__UpdateSearchHistory;